<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_vii"></a>ACKNOWLEDGMENTS</h2>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="noindent">To the United States Navy, Marines, Air Force, and Army; for the assistance in the writing of this novel, you have my deepest thanks.</p>
<p class="indent">To the United States Geological Service and the help that was given on theory and science. The assistance rendered was far beyond anything and I am grateful.</p>
<p class="indent">For Pete Wolverton, who always reminds me I can be better than the first draft (and sometimes better than even the second).</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknow.vue?36ea81c8